import React from 'react';
import ReactDOM from 'react-dom/client';
// One type family (Design Standard v1): Inter, self-hosted — 400 body, 500 labels, 600 headings.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import './index.css';
import './setupAxios';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { BUILD_COMMIT, BUILD_BRANCH, BUILD_TIME } from './buildInfo';

// TRIPWIRE — the exact commit this bundle was built from, logged on every load.
// The commit is baked into src/buildInfo.js by scripts/gen-build-info.js, which
// runs on prebuild/prestart — so EVERY build carries it, even a bare `npm run
// build` that bypasses deploy.sh (that gap once shipped commit=unknown to prod).
// Khalis (or anyone) can open the console and read the build hash in one look.
// Pairs with GET /api/version/ on crm-api.
// eslint-disable-next-line no-console
console.log(`[build] crm-frontend commit=${BUILD_COMMIT} branch=${BUILD_BRANCH} built=${BUILD_TIME || 'n/a'} bundle=${document.currentScript?.src || 'n/a'}`);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
